import { BILLING_SERVICE_URL } from '@/config/env.ts';
import { createBillingApiClient } from '@jogolabs/billing-sdk';
import { SESSION_KEY } from '@/config/constants.ts';

export const billingApiClient = createBillingApiClient(
  BILLING_SERVICE_URL,
  window.localStorage.getItem(SESSION_KEY) || ''
);
